import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPdfView = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M9 12H6V6H9C10.6568 6 12 7.34314 12 9C12 10.6568 10.6568 12 9 12ZM7.5 7.5V10.5H9C9.82845 10.5 10.5 9.82845 10.5 9C10.5 8.17155 9.82845 7.5 9 7.5H7.5ZM11.25 3H3.75V15H14.25V6H11.25V3ZM2.25 2.24385C2.25 1.83304 2.58562 1.5 2.99888 1.5H12L15.7498 5.25L15.75 15.7444C15.75 16.1617 15.4163 16.5 15.0049 16.5H2.99505C2.58357 16.5 2.25 16.1585 2.25 15.7561V2.24385Z",
			fill: "currentColor"
		})
	})
});
export default SvgPdfView;
